import type { IClothing } from '@typings';

export const createCategoryCounter = (selectedClothes: IClothing[]) => {
	return selectedClothes.reduce((acc, item) => {
		const cat = item.category.toLowerCase();
		acc[cat] = (acc[cat] || 0) + 1;
		return acc;
	}, {} as Record<string, number>);
};
